import React from 'react';
import ProtectedEmail from '../components/ProtectedEmail';

const Contact: React.FC = () => {

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Liên hệ với chúng tôi</h1>
          <p>Chúng tôi sẵn sàng tư vấn và hỗ trợ bạn 24/7</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ gap: '4rem', alignItems: 'start' }}>
            {/* Contact Information */}
            <div className="card">
              <h3>Thông tin liên hệ</h3>
              <p style={{ marginBottom: '2rem', fontSize: '1.1rem' }}>
                Chúng tôi sẵn sàng tư vấn và hỗ trợ bạn về các sản phẩm gỗ và dịch vụ. 
                Hãy liên hệ trực tiếp với chúng tôi qua các kênh sau:
              </p>
              
              <div style={{ marginBottom: '2rem' }}>
                <h4 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>📞 Gọi điện thoại</h4>
                <p style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>
                  <strong>
                    <a href="tel:0915444447" style={{ color: 'var(--primary-color)', textDecoration: 'none' }}>
                      0915 444 447
                    </a>
                  </strong> (anh Kiên)
                </p>
                <p style={{ fontSize: '1.2rem' }}>
                  <strong>
                    <a href="tel:0906838171" style={{ color: 'var(--primary-color)', textDecoration: 'none' }}>
                      0906 838 171
                    </a>
                  </strong> (cô Nhung)
                </p>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h4 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>📧 Email</h4>
                <p style={{ fontSize: '1.1rem' }}>
                  <ProtectedEmail 
                    email="ducphatdatco@gmail.com"
                    style={{ color: 'var(--primary-color)', fontSize: '1.1rem' }}
                  />
                </p>
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <h4 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>📍 Địa chỉ</h4>
                <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
                  Số 2 Hoàng Hữu Nam<br />
                  Phường Long Bình, TP HCM
                </p>
                <a 
                  href="https://goo.gl/maps/v3FYpZXcdGvYEdc39?g_st=az" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                  style={{ fontSize: '0.9rem' }}
                >
                  Xem trên Google Maps
                </a>
              </div>
            </div>

            {/* Additional Information */}
            <div>
              <div className="card">
                <h3>Giờ làm việc</h3>
                <div style={{ lineHeight: '1.8' }}>
                  <div><strong>Thứ 2 - Thứ 6:</strong> 8:00 - 17:00</div>
                  <div><strong>Thứ 7:</strong> 8:00 - 12:00</div>
                  <div><strong>Chủ nhật:</strong> Nghỉ</div>
                </div>
                <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: 'var(--text-light)' }}>
                  <em>Chúng tôi có thể hỗ trợ ngoài giờ cho các trường hợp khẩn cấp.</em>
                </p>
              </div>

              <div className="card">
                <h3>Tại sao chọn chúng tôi?</h3>
                <ul style={{ lineHeight: '1.8' }}>
                  <li>✅ Hơn 15 năm kinh nghiệm trong ngành gỗ</li>
                  <li>✅ Chất lượng sản phẩm đảm bảo</li>
                  <li>✅ Giá cả cạnh tranh</li>
                  <li>✅ Dịch vụ chuyên nghiệp</li>
                  <li>✅ Giao hàng nhanh chóng</li>
                  <li>✅ Hỗ trợ tư vấn 24/7</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Contact */}
      <section className="section bg-light">
        <div className="container text-center">
          <h2>Cần hỗ trợ khẩn cấp?</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
            Gọi ngay hotline để được hỗ trợ nhanh chóng
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
            <a 
              href="tel:0915444447" 
              className="btn btn-primary"
              style={{ fontSize: '1.1rem', padding: '1rem 2rem' }}
            >
              📞 0915 444 447 (anh Kiên)
            </a>
            <a 
              href="tel:0906838171" 
              className="btn btn-secondary"
              style={{ fontSize: '1.1rem', padding: '1rem 2rem' }}
            >
              📞 0906 838 171 (cô Nhung)
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
